import { observer } from 'mobx-react-lite';
import React from 'react';
import arrowLeft from '../../../assets/arrowLeftBlack.svg';
import { useMst } from '../../../models/rootModel';
import { MainButtonVariant } from '../../styledComponent/Buttons.style';
import { MainTitleDescription } from '../MainTitleDescription';
import { BaseStepPropsV2 } from './BaseStepV2.types';
import { MainContentBox } from './Box/Box.style';
import { StepV2ConfirmButton } from './StepV2ConfirmButton';
import {
  BackArrowImg,
  DesktopButtonWrapper,
  HeaderContainer,
  Section,
  SkipText,
  StickyMobileButtonWrapper,
} from './StepV2MainContent.style';
import { useAnalytics } from '../../../utils/analytics';

type PropsWithHiddenSubmitButton = {
  hideSubmitButton: true;
};

type PropsWithVisibleSubmitButton = {
  hideSubmitButton?: false;
  isButtonDisabled: boolean;
  isLoading: boolean;
  onButtonClick: () => void;
  buttonVariant?: MainButtonVariant;
};

type StepV2MainContentProps = BaseStepPropsV2 & {
  backCallback?: () => void;
  styleProps?: {
    wrapper?: {
      unsetPadding: boolean;
    };
    desktopButtonWrapper?: {
      maxWidth?: number;
      marginTop?: number;
      marginLeft?: number;
    };
    mobileButtonWrapper?: {
      hideBorder?: boolean;
    };
  };
} & (PropsWithHiddenSubmitButton | PropsWithVisibleSubmitButton);

export const StepV2MainContent: React.FC<StepV2MainContentProps> = observer((props) => {
  const { UserProgress } = useMst();
  const analytics = useAnalytics();

  const handlePreviousStep = () => {
    if (props.previousStepId) {
      UserProgress.goToParticularStep(props.previousStepId, props.goToNamedStep);
    } else {
      UserProgress.back(props.goToNamedStep);
    }

    props.backCallback && props.backCallback();
  };

  const onPressSkip = () => {
    analytics.track(`click skip`, { page: props.stepType });
    props.nextStep();
  };
  return (
    <MainContentBox unsetPadding={props.styleProps?.wrapper?.unsetPadding}>
      {(props.canGoBack || props.canSkip) && (
        <HeaderContainer>
          {props.canGoBack ? <BackArrowImg alt="←" src={arrowLeft} onClick={handlePreviousStep} /> : null}
          {props.canSkip ? <SkipText onClick={onPressSkip}>Skip</SkipText> : null}
        </HeaderContainer>
      )}

      {props.section && <Section>{props.section}</Section>}
      {(props.title || props.description) && (
        <MainTitleDescription
          {...props}
          forBaseStepV2={true}
          extraSpace={!!!props.section && props.canGoBack}
        ></MainTitleDescription>
      )}

      {props.children}
      {!props.hideSubmitButton && (
        <>
          <DesktopButtonWrapper
            maxWidth={props.styleProps?.desktopButtonWrapper?.maxWidth}
            marginTop={props.styleProps?.desktopButtonWrapper?.marginTop}
            marginleft={props.styleProps?.desktopButtonWrapper?.marginLeft}
          >
            <StepV2ConfirmButton {...props} onClick={props.onButtonClick} variant={props.buttonVariant} />
          </DesktopButtonWrapper>
          <StickyMobileButtonWrapper hideBorder={props.styleProps?.mobileButtonWrapper?.hideBorder}>
            <StepV2ConfirmButton {...props} onClick={props.onButtonClick} variant={props.buttonVariant} />
          </StickyMobileButtonWrapper>
        </>
      )}
    </MainContentBox>
  );
});
